import { z } from "zod";
import { custodianOptions } from "../../Types";
import { MarketplaceAssetType, MarketplaceOffering, MarketplaceOfferingType, } from "../Types";
export const aumPlaceValueArray = [
    "Thousand",
    "Million",
    "Billion",
    "Trillion",
    "N/A",
];
export const AumDenomination = z.enum([
    "Thousand",
    "Million",
    "Billion",
    "Trillion",
    "N/A",
]);
export const accessTypesArray = [
    "Feeder Fund",
    "Direct Fund",
    "ETF",
    "Private Investment",
    "N/A",
];
export const AccessTypes = z.enum([
    "Feeder Fund",
    "Direct Fund",
    "ETF",
    "Private Investment",
    "N/A",
]);
export const KeyInvestor = z.object({
    investor: z.string().array(),
});
export const VentureCapitalVertical = z.enum([
    "3D Printing",
    "Autonomous Drones",
    "Digital Assets",
    "E-Commerce",
    "FinTech",
    "Fitness Wearables",
    "FoodTech",
    "Logistics Tech",
    "Marketing Software",
    "Productivity Software",
    "Software (RPA)",
    "Sustainable Materials",
]);
export const AltAssetUrlTypes = [
    "hedge-fund",
    "private-equity",
    "venture-capital",
    "venture-capital-fund",
    "wine-and-spirit",
    "artwork",
];
export const ventureCapitalVerticalArray = [
    "3D Printing",
    "Autonomous Drones",
    "Digital Assets",
    "E-Commerce",
    "FinTech",
    "Fitness Wearables",
    "FoodTech",
    "Logistics Tech",
    "Marketing Software",
    "Productivity Software",
    "Software (RPA)",
    "Sustainable Materials",
];
export const SMAAssetId = z.custom((val) => typeof val === "string");
export const SMAAsset = z.object({
    assetId: SMAAssetId,
    firmName: z.string(),
    shortDescription: z.string(),
    longDescription: z.string(),
    minimumInvestment: z.string().nullable(),
    feeRange: z.string().nullable(),
    featuredStrategy: z.string().array(),
    custodianAvailability: z.enum(custodianOptions).array(),
    contactInfoName: z.string(),
    contactInfoPhone: z.string().nullable(),
    contactInfoEmail: z.string().nullable(),
});
export const PostMarketplaceOfferingsQueryBodyParams = z.object({
    searchByKeyword: z.string().optional(),
    filterBy: z.object({
        assetType: MarketplaceAssetType.array().optional(),
        offeringType: MarketplaceOfferingType.array().optional(),
        dynamicParameters: z
            .object({
            objective: z.string().array().optional(),
            strategy: z.string().array().optional(),
            "sub-strategy": z.string().array().optional(),
            minimum_investment: z.string().array().optional(),
            investor_qualification: z.string().array().optional(),
            liquidity: z.string().array().optional(),
            subscriptions: z.string().array().optional(),
            "lock-up": z.string().array().optional(),
        })
            .optional(),
    }),
    pagination: z
        .object({
        page: z.number(),
        pageSize: z.number(),
    })
        .optional(),
});
export const PostMarketplaceOfferingsQueryResponse = z.object({
    values: MarketplaceOffering.shape.v2.array(),
});
//# sourceMappingURL=Types.js.map